// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Stack,
  Typography,
  Link,
  useTheme,
  useMediaQuery,
  Grid,
  Box,
  Divider,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { LoginBG, Logo150 } from "../../assets/images";
import { Button, Loading } from "../atoms";
import { zodResolver } from "@hookform/resolvers/zod";
import { InputControl, MaskedPasswordControl } from "../molecules";
import { signInFormSchema, SignInFormValuesType } from "./_types";
import { OtpFormModal, ForgotPasswordModal } from "../organisms";
import { useGetPasswordMaxLengthSettingsList, useLogin } from "../../hooks";
import { useEffect, useState, useMemo } from "react";
import { StorageKeys } from "../../common/storageKeys";
import { axiosInstance } from "../../config/axios";
import { useUserInfo } from "../../store/User.state";
import { useSetSnackBar } from "../../store/Snackbar.state";
import { useNavigate } from "react-router-dom";

import leftCircleImage from "../../assets/images/left-circle.png";
import rightCircleImage from "../../assets/images/right-circle.png";

export const LoginTemplate = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const { mutate: login, isLoading } = useLogin();
  const setSnackbar = useSetSnackBar();
  const [, setUserInfo] = useUserInfo();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isForgotModalOpen, setIsForgotModalOpen] = useState(false);

  const { handleSubmit, control } = useForm<SignInFormValuesType>({
    resolver: zodResolver(signInFormSchema),
  });

  const [maxLength, setMaxLength] = useState(null);
  const { data: maxLengthSettings } = useGetPasswordMaxLengthSettingsList({});

  useEffect(() => {
    const val = maxLengthSettings?.data?.result?.[0]?.value;
    if (val) setMaxLength(val);
  }, [maxLengthSettings]);

  const onSubmit = ({ email, password }: SignInFormValuesType) => {
    login(
      { email, password },
      {
        onSuccess(data) {
          if (data.isSuccess) {
            setIsModalOpen(true);
            setUserInfo(data.data);

            Object.entries({
              [StorageKeys.bearerToken]: data.data.token,
              [StorageKeys.userName]: data.data.fullName,
              [StorageKeys.order]: data.data.order,
              [StorageKeys.level]: data.data.level,
              [StorageKeys.userId]: data.data.userId,
              [StorageKeys.expireDate]: data.data.expireDate,
              [StorageKeys.merchantId]: data.data.merchantId,
              [StorageKeys.systemPassword]: data.data.systemPassword,
              [StorageKeys.merchantName]: data.data.merchantName,
              [StorageKeys.isPayoutBlocked]: data.data.isPayoutBlocked,
              [StorageKeys.payoutBlockReason]: data.data.payoutBlockReason,
              [StorageKeys.userType]: data.data.userType,
            }).forEach(([k, v]) => localStorage.setItem(k, v));

            axiosInstance.interceptors.request.use((config) => {
              config.headers["Authorization"] = `Bearer ${data.data.token}`;
              return config;
            });
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
      }
    );
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem(StorageKeys.bearerToken)) {
      navigate("/dashboard");
    }
  }, []);

  const randomPassName = useMemo(() => "field_" + Math.random().toString(36).substring(2, 9), []);

  return (
    <>
      {isLoading && <Loading />}

      <Stack
        direction="column"
        height="100vh"
        overflow={isDesktop ? "hidden" : "auto"}
        sx={{ backgroundColor: "#fff" }}
      >
        <Box sx={{ position: "fixed", bottom: 0, zIndex: 0, opacity: 0.3 }}>
          <img src={leftCircleImage} />
        </Box>
        <Box sx={{ position: "fixed", right: 0, bottom: 0, opacity: 0.3 }}>
          <img src={rightCircleImage} />
        </Box>

        <Stack
          flex={1}
          justifyContent="center"
          alignItems="center"
          onKeyDown={(e) => e.key === "Enter" && handleSubmit(onSubmit)()}
        >
          <Stack
            spacing={3}
            borderRadius={6}
            backgroundColor="#FFF"
            p={6}
            width={isDesktop ? "1450px" : "90%"}
            height={isDesktop ? 700 : "95%"}
            sx={{
              boxShadow: "0 2px 4px 0 rgba(0,0,0,.15)",
              border: "1px solid rgba(0,0,0,.08)",
              zIndex: 1,
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} md={6}>
                <Box sx={{ textAlign: "center" }}>
                  <img
                    style={{
                      height: isDesktop ? "100%" : "80%",
                      width: isDesktop ? "100%" : "80%",
                      objectFit: "contain",
                    }}
                    src={LoginBG}
                    alt="login background"
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={1}>
                <Divider
                  orientation={isDesktop ? "vertical" : "horizontal"}
                  sx={{ width: isDesktop ? "50px" : "100%" }}
                />
              </Grid>

              <Grid item xs={12} md={5} sx={{ alignContent: "center" }}>
                <Box
                  sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
                >
                  <Stack direction="column" alignItems="center">
                    <Box textAlign="center">
                      <img width={isDesktop ? 300 : 200} src={Logo150} alt="logo" />
                    </Box>
                    <Typography variant="h4">Hoşgeldiniz!</Typography>
                  </Stack>

                  <Box
                    component="form"
                    autoComplete="off"
                    sx={{ mt: 3, width: "100%" }}
                    onSubmit={handleSubmit(onSubmit)}
                  >

                    <InputControl
                      name="email"
                      id="username"
                      type="text"
                      control={control}
                      label="E-Posta / Kullanıcı Adı"
                      autoComplete="email"
                      sx={{ width: "100%", mb: 1 }}
                    />

                    <MaskedPasswordControl
                      name="password"
                      id={randomPassName}
                      control={control}
                      label="Şifre"
                      maxLength={maxLength}
                      sx={{ width: "100%", mb: 1 }}
                    />

                    <Link
                      component="button"
                      type="button"
                      variant="body2"
                      sx={{ textAlign: "right", width: "100%" }}
                      onClick={() => setIsForgotModalOpen(true)}
                    >
                      Parolamı unuttum
                    </Link>

                    <Stack mt={2} alignItems="center">
                      <Button
                        type="submit"
                        sx={{ width: 240, mb: 3 }}
                        size="large"
                        variant="contained"
                        text="Giriş Yap"
                      />

                      <Link
                        component="button"
                        variant="body2"
                        onClick={() =>
                          window.open("https://www.ahlpay.com.tr", "_blank")
                        }
                      >
                        Henüz bir hesabınız yok mu?
                      </Link>
                    </Stack>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Stack>
        </Stack>
      </Stack>

      {isModalOpen && <OtpFormModal isOpen={isModalOpen} />}
      {isForgotModalOpen && (
        <ForgotPasswordModal
          isOpen={isForgotModalOpen}
          onClose={() => setIsForgotModalOpen(false)}
        />
      )}
    </>
  );
};
